import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import storeLoader from 'app/stores/storeLoader';
import { RadioGroup, Select, Field, formConsumer } from 'core/form';
import { Box, Flex, Text, Heading, Callout } from 'core/components';
import DashboardSelector from 'app/views/core/dashboards/DashboardSelector';
import { AGGREGATE_VIEWS, QUICK_VIEW_ROUTE } from 'app/views/core';
import { orderBy } from 'lodash';

@storeLoader('$dashboards', '$savedViews')
@inject('$auth', '$dictionary', '$app')
@formConsumer
@observer
export default class RoleSetLandingPage extends Component {
  generateQuickViewOptions = () => {
    const quickViewOptions = AGGREGATE_VIEWS.map((view) => ({
      value: view.path.replace(`${QUICK_VIEW_ROUTE}/`, ''),
      label: view.name
    }));
    return orderBy(quickViewOptions, 'name');
  };

  getLandingPageTypeOptions = (form) => {
    const { $auth, $savedViews } = this.props;
    const landingPageOptions = [
      {
        label: 'User Local (default)',
        value: 'local'
      },
      {
        label: 'Observation Deck',
        value: 'observationDeck'
      },
      {
        label: 'NMS Dashboard',
        value: 'nmsDashboard'
      },
      {
        label: 'Network Explorer',
        value: 'networkExplorer'
      },
      {
        label: 'Library',
        value: 'library'
      },
      {
        label: 'Synthetics',
        value: 'synthetics'
      },
      {
        label: 'Data Explorer',
        value: 'explorer'
      },
      {
        label: 'Alerting',
        value: 'alerting'
      },
      {
        label: 'Insights',
        value: 'insights'
      },
      {
        label: (
          <Box>
            <Text as="div">Dashboard</Text>
            {form.getValue('config.landingPageType') === 'dashboard' && (
              <DashboardSelector menuWidth={235} mt={1} name="config.landingPageValue" />
            )}
          </Box>
        ),
        value: 'dashboard'
      },
      {
        label: (
          <Box>
            <Text as="div">Saved View</Text>
            {form.getValue('config.landingPageType') === 'saved-view' && (
              <Field
                name="config.landingPageValue"
                options={$savedViews.collection.generateSelectOptions({ labelKey: 'view_name' })}
                mt={1}
              >
                <Select showFilter menuWidth={235} />
              </Field>
            )}
          </Box>
        ),
        value: 'saved-view'
      },
      {
        label: (
          <Box>
            <Text as="div">Quick View</Text>
            {form.getValue('config.landingPageType') === 'quick-view' && (
              <Field name="config.landingPageValue" options={this.generateQuickViewOptions()} mt={1}>
                <Select showFilter menuWidth={235} />
              </Field>
            )}
          </Box>
        ),
        value: 'quick-view'
      }
    ];

    if ($auth.hasPermission('marketIntel.enabled')) {
      landingPageOptions.push({
        label: 'Market Intelligence',
        value: 'market-intel'
      });
    }
    return landingPageOptions;
  };

  onLandingPageTypeChange = () => {
    const { form } = this.props;
    form.getField('config.landingPageValue').init(undefined);
  };

  render() {
    const { form } = this.props;
    return (
      <Box mt={2}>
        <Heading level={6}>Default Settings</Heading>
        <Callout p={2}>
          <Flex>
            <Box width={256}>
              <Field
                mb={0}
                name="config.landingPageType"
                large
                options={this.getLandingPageTypeOptions(form)}
                onChange={this.onLandingPageTypeChange}
              >
                <RadioGroup large />
              </Field>
            </Box>
            <Box flex={1} />
          </Flex>
        </Callout>
      </Box>
    );
  }
}
